import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "recovery-success"
};
const _hoisted_2 = {
  class: "header-section"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " Back to login ", -1);
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 0,
  class: "btn-row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_new_logo_with_omny = _resolveComponent("new-logo-with-omny");
  const _component_stroked_chevron_left_icon = _resolveComponent("stroked-chevron-left-icon");
  const _component_app_button = _resolveComponent("app-button");
  const _component_app_form = _resolveComponent("app-form");
  const _component_the_wrapper_public_v2 = _resolveComponent("the-wrapper-public-v2");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_the_wrapper_public_v2, null, {
    "left-side": _withCtx(() => [_createTextVNode(_toDisplayString(null))]),
    default: _withCtx(() => [_createVNode(_component_new_logo_with_omny), _createVNode(_component_app_form, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [$props.type === 'recovery' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = (...args) => $options.loginPage && $options.loginPage(...args)),
        class: "back-btn"
      }, [_createVNode(_component_stroked_chevron_left_icon), _hoisted_3])) : _createCommentVNode("", true), _createElementVNode("h1", null, _toDisplayString($data.titles[$props.type]), 1)]), _createElementVNode("p", {
        class: "success-notice",
        innerHTML: $data.descriptions[$props.type]
      }, null, 8, _hoisted_4), $props.type !== 'recovery' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_app_button, {
        type: "submit",
        onClick: $options.loginPage
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.loginBtnText[$props.type]), 1)]),
        _: 1
      }, 8, ["onClick"])])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })]);
}